import {getFrontendEnvironment} from "../../utils/environment";

const {credentials, environment} = getFrontendEnvironment();

// In deployed environments the translation records live at /static/i18n on
// every origin: app.*, trust.*, collect.*, and customer custom domains all
// proxy /static/* to the shared static bucket. Fetching them from the page's
// own origin keeps a page on a custom (or trust/collect) domain from depending
// on a cross-origin request to app.*, which customer networks and content
// blockers can drop — leaving those visitors with untranslated keys. Local dev
// and integration tests serve no /static/i18n of their own, so they fetch from
// the absolute CDN URL in the environment (which points at a deployed bucket).
//
// Tolgee appends `/<language>.json` (or `/<namespace>/<language>.json`), so
// every record URL sits under this prefix.
export const tolgeeBackendPrefix = (() => {
  const deployed = environment === "staging" || environment === "production";
  if (deployed) {
    try {
      return new URL(credentials.tolgee_cdn).pathname;
    } catch {
      // Not a parseable absolute URL — fall back to the raw configured value.
    }
  }
  return credentials.tolgee_cdn;
})();
